enum CalendarLegends {
  Unassigned = 'Unassigned',
  EventDate = 'Event date',
  ExaminationDate = 'Examination date',
  TrialDate = 'Trial date'
};

export default CalendarLegends;
